<template>
  <div>
    <form id="payment-form">
      <br />
      <div id="payment-element"></div>
      <div id="card-errors"></div>
      <br />
      <el-button id="button-text" style="display: none" @click="confirm">
        <div class="spinner hidden" id="spinner"></div>
        <span>
          使用新的支付方式 👉 下一步
        </span>
      </el-button>
      <div id="payment-message" class="hidden">{{ errorMessage }}</div>
      <br />
    </form>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import $ from "jquery";

export default {
  data() {
    return {
      intent: "",
      name: "",
      stripe: {},
      elements: {},
      errorMessage: "",
      paymentElement: {}
    };
  },
  props: ["plan"],
  computed: {
    ...mapState(["user", "theme"])
  },
  components: {},
  methods: {
    ...mapMutations(["setLoading"]),
    async confirm() {
      this.setLoading(true);
      let options = {
        elements: this.elements,
        confirmParams: {
          return_url:
            (process.env.VUE_APP_STRIPE_RETURN_URL ||
              "https://99huaren.com/user/subscription") +
            "?plan=" +
            this.plan
        }
      };
      const { error } = await this.stripe.confirmSetup(options);

      if (error) {
        this.errorMessage = error.message;
        this.$message({
          showClose: true,
          type: "error",
          message: error.message
        });
      }
      // if (error.type === "card_error" || error.type === "validation_error") {
      //   this.$message.error(error.message);
      // } else {
      //   this.$message.error("支付出错，请稍后重试！");
      // }
      this.setLoading(false);
    },
    fetchSetupIntent() {
      this.$http.get(`/user/payment/intent`).then(res => {
        this.intent = res.data.clientSecret;
        this.mountPaymentElement();
      });
    },
    fetchPaymentIntent() {
      this.$http.get(`/user/subscription/intent/` + this.plan).then(res => {
        this.intent = res.data.clientSecret;
        this.mountPaymentElement();
      });
    },
    mountPaymentElement() {
      const appearance = {
        theme: this.theme === "dark" ? "night" : "stripe",
        labels: "floating"
      };
      let elementStyles = {
        clientSecret: this.intent,
        appearance: appearance
      };
      this.elements = this.stripe.elements(elementStyles);
      this.paymentElement = this.elements.create("payment");
      this.paymentElement.mount("#payment-element");
      $("#button-text").show();
    }
  },
  // set the layout to user when it's mounted.
  mounted: function() {
    this.stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
    this.fetchSetupIntent();
  }
};
</script>
<style></style>
